import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EmployeesResponse, MyTeamResponse } from '../models/employee';
import { AssignedCoursesResponse } from '../models/course';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {
  private readonly baseUrl = `${environment.BASE_URL}${environment.BASE_API.EMPLOYEES}`;
  private readonly assignedBase = `${environment.BASE_URL}${environment.BASE_API.COURSE_ASSIGNED}`;
  private readonly myTeamUrl = `${environment.BASE_URL}${environment.BASE_API.MYTEAM}`;

  constructor(private http: HttpClient) {}

  getEmployees(): Observable<EmployeesResponse> {
    return this.http.get<EmployeesResponse>(this.baseUrl);
  }

  getAssignedFor(member: string): Observable<AssignedCoursesResponse> {
    const m = encodeURIComponent(member);
    return this.http.get<AssignedCoursesResponse>(`${this.assignedBase}/${m}`);
  }

  getMyTeam(): Observable<MyTeamResponse> {
    return this.http.get<MyTeamResponse>(this.myTeamUrl);
  }
}


